import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Icon, { Line, Path, Polyline, Rect } from './base/Icon';
import type { BaseIconProps } from './types';
type AwardProps = BaseIconProps;
const Award: React.FC<AwardProps> = t0 => {
  const $ = _c(13);
  let color;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      color,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = props;
    $[3] = t1;
  } else {
    color = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = color || "rgba(var(--primary-color))";
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Polyline points="20 12 20 22 4 22 4 12" />;
    t4 = <Rect x="2" y="7" width="20" height="5" />;
    t5 = <Line x1="12" y1="22" x2="12" y2="7" />;
    t6 = <Path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />;
    t7 = <Path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== props || $[10] !== size || $[11] !== t2) {
    t8 = <Icon {...props} size={size} color={t2} strokeWidth="3">{t3}{t4}{t5}{t6}{t7}</Icon>;
    $[9] = props;
    $[10] = size;
    $[11] = t2;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  return t8;
};
export default Award;